import app, { appIds } from '$$app';
import plansModel from '../../models/plans';
import projectsModel from '$$projectModel';
import driverJsPlugin from './driverJsPlugin';

const { popupViews: { ID_VIEW_POPUP_GLOBALSEARCH } } = appIds;

function toggleGlobalSearchIfNeeded(e) {
  if (
    (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70))
    && (plansModel.isActiveTrial() || plansModel.isActiveSubscription())
    && projectsModel.getAllProjects().length > 0
  ) {
    e.preventDefault();

    const __$$globalSearchWndView = $$(ID_VIEW_POPUP_GLOBALSEARCH);

    if (__$$globalSearchWndView.isShown()) {
      __$$globalSearchWndView.hide();
    } else {
      __$$globalSearchWndView.show();
    }
  }
}

function fireEventOnEscKeyPressed(e) {
  if (e.keyCode === 27) {
    app.trigger('closeWindowOnEscKeyPressed');
  }
}

function onKeyDown(e) {
  toggleGlobalSearchIfNeeded(e);
  driverJsPlugin.keyPressCancel(e); // only for keydown
  fireEventOnEscKeyPressed(e);
}

function onClick(e) {
  if (e.target.closest('.js_header') || e.target.closest('.left-sidebar')) {
    app.trigger('gantt:keyboard:unselect');
  }

  if (
    (e.target.closest('.js_header')
      || e.target.closest('.left-sidebar')
      || e.target.closest('.board_container')
      || e.target.closest('.listview_container')
      || e.target.closest('.toolbar_filter_button'))
    // && !e.target.closest('.js_filter_btn') // [fix]: close the slack popup when the filter button is clicked
    && !e.target.closest('.js_settings_btn')
    && !e.target.closest('.js_slack_btn')
  ) {
    app.trigger('closeWindowWithAnimation');
  }
}

export default {
  searchWindowListeners: [],
  init() {
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('click', onClick);

    this.searchWindowListeners.push($$('globalSearchWindowId').attachEvent('onShow', () => {
      app.trigger('gantt:keyboard:disable');
    }));

    this.searchWindowListeners.push($$('globalSearchWindowId').attachEvent('onAfterAnimationHide', () => {
      app.trigger('gantt:keyboard:enable');
    }));
  },
  destroy() {
    document.removeEventListener('keydown', onKeyDown);
    document.removeEventListener('click', onClick);

    this.searchWindowListeners.forEach(event => $$('globalSearchWindowId').detachEvent(event));
    this.searchWindowListeners = [];
  },
};
